import React from 'react';
import PropTypes from 'prop-types';
import { transformPrompt } from '../../../../../../utils';

export default function RowLabels({ rowLabels, minWidth }) {
  return (
    <div className="bipolar-horizontal-row-labels" style={{ minWidth }}>
      <span
        className="bipolar-horizontal-row-label bipolar-horizontal-row-label--left inline-children"
        // eslint-disable-next-line react/no-danger
        dangerouslySetInnerHTML={{
          __html: transformPrompt(rowLabels.beforeLabel) || '&nbsp;',
        }}
      ></span>
      <span
        className="bipolar-horizontal-row-label bipolar-horizontal-row-label--right inline-children" // eslint-disable-next-line react/no-danger
        dangerouslySetInnerHTML={{
          __html: transformPrompt(rowLabels.afterLabel) || '&nbsp;',
        }}
      ></span>
    </div>
  );
}
RowLabels.propTypes = {
  rowLabels: PropTypes.array,
  minWidth: PropTypes.number,
};
